import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'InvoiceType';
const ENDPOINT = `/invoice-types/`;

@Injectable({
    providedIn: 'root'
})
export class InvoiceTypeService extends ServiceBase {

    protected override useCache = true;

    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
